import { useEffect, useRef, useState } from "react";
import React from "react";

const testimonials = [
  {
    name: "Hari Shah",
    role: "Design Director, Luxe Interiors",
    text: "Professional service and top-quality products. KSU’s concealed hinges are perfect for our luxury furniture line.",
    image: "test2.jpg",
  },
  {
    name: "Sarah",
    role: "Project Manager, Residential Construction",
    text: "Outstanding durability and precision. We’ve used KSU hinges in over 60+ residential units with zero failures.",
    image: "test3.jpg",
  },
  {
    name: "Raj",
    role: "Facilities Manager, Architecture Industries",
    text: "The custom heavy-duty hinges for our warehouse doors have performed flawlessly for 3 years. Excellent investment.",
    image: "test1.jpg",
  },
];

const stats = [
  { value: 99, suffix: "%", label: "Customer Satisfaction" },
  { value: 100, suffix: "+", label: "Projects Completed" },
  { value: 24, suffix: "/7", label: "Technical Support" },
  { value: 10, suffix: "+", label: "Years Experience" },
];

// Subcomponent to animate counting
const StatItem = ({ value, suffix, label }) => {
  const [count, setCount] = useState(0);
  const [trigger, setTrigger] = useState(false);
  const itemRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !trigger) {
          setTrigger(true);
          observer.disconnect();
        }
      },
      { threshold: 0.4 }
    );

    if (itemRef.current) observer.observe(itemRef.current);
    return () => observer.disconnect();
  }, [trigger]);

  useEffect(() => {
    if (!trigger) return;

    let start = 0;
    const duration = 1000; // 1 second
    const stepTime = Math.max(Math.floor(duration / value), 20);

    const counter = setInterval(() => {
      start += 1;
      setCount(start);
      if (start >= value) clearInterval(counter);
    }, stepTime);

    return () => clearInterval(counter);
  }, [trigger, value]);

  return (
    <div ref={itemRef}>
      <p className="text-2xl font-bold text-blue-600">
        {count}
        {suffix}
      </p>
      <p className="text-sm text-gray-600 mt-1">{label}</p>
    </div>
  );
};

export default function Testimonial() {
  return (
    <section className="py-16 mt-[5%] md:mt-[3%] bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-4xl text-shadow font-bold text-center text-gray-800">
          Testimonials
        </h2>
        <p className="text-center text-gray-500 mt-2 mb-10">
          Trusted by industry professionals worldwide for exceptional quality
          and reliability
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {testimonials.map((t, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-lg shadow-sm p-6 text-center"
            >
              <div className="flex justify-start mb-3">
                {[...Array(5)].map((_, i) => (
                  <i
                    key={i}
                    className="fa-solid fa-star text-2xl text-yellow-400"
                  ></i>
                ))}
              </div>
              <p className="text-gray-600 italic mb-4">"{t.text}"</p>
              <div className="flex items-center justify-start gap-3">
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-10 h-10 rounded-full"
                />
                <div className="text-left">
                  <p className="text-sm font-semibold text-gray-800">
                    {t.name}
                  </p>
                  <p className="text-xs text-gray-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Animated Stats Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center bg-gray-100 py-8 rounded-xl">
          {stats.map((stat, i) => (
            <StatItem key={i} {...stat} />
          ))}
        </div>
      </div>

      <section className="px-4 py-12">
        {/* Blue CTA Banner */}
        <div className="bg-[#02347B] rounded-lg text-white px-6 py-10 text-center mb-16">
          <h2 className="text-xl md:text-2xl font-semibold mb-2">
            Join Our Satisfied Customers
          </h2>
          <p className="text-sm md:text-base mb-6">
            Experience the quality and reliability that industry professionals
            trust
          </p>
          <div className="flex flex-col md:flex-row justify-center gap-4">
            <button
              onClick={() => window.open("https://wa.link/ji1hnl", "_blank")}
              className="bg-white text-blue-600 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition-all duration-300"
            >
              Request Quote
            </button>
            <button onClick={() => window.open("https://share.google/7mH6SZvTSU4gQ0TOc", "_blank")} className="border border-white text-white font-semibold py-2 px-6 rounded-md hover:bg-blue-500 transition-all duration-300">
              View Case Studies
            </button>
          </div>
        </div>

        {/* Premium Products Section */}
        <div className="text-center text-shadow max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
            Discover Our Premium Products
          </h2>
          <p className="text-gray-600 mb-6 text-sm md:text-base">
            Browse our extensive catalog of high-quality hinges and hardware
            solutions tailored for your needs.
          </p>
          <div className="flex justify-center gap-4">
            <button
              className="bg-blue-600 text-white hover:bg-blue-800 transition-all duration-300 font-semibold py-2 px-6 rounded-md"
              onClick={() =>
                window.open(
                  "https://www.instagram.com/ksu.hinge?igsh=d3F1MzJlZXJnZXc2",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              Explore
            </button>
            <a
              href="https://mail.google.com/mail/?view=cm&fs=1&to=Kantadevienterprises@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="bg-gray-100 text-black font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition-all duration-300">
                Contact
              </button>
            </a>
          </div>
        </div>
      </section>
    </section>
  );
}
